/**
 * Estado de navegação para abrir o M6 já num instrumento — C-24. TS puro.
 *
 * Vai no `location.state`, como o `openPlanoNavState`. Com o `BrowserRouter` ele fica no
 * `history.state`: sobrevive ao F5 e ao voltar/avançar, então um refresh reabre o
 * instrumento que veio do sino. Sem pedido, o M6 abre no primeiro instrumento da lista.
 */

interface InstrumentoNavState {
  instrumentoId: string;
}

/** `state` para `navigate('/instrumentacao', { state })` abrir no instrumento. */
export function verInstrumentoNavState(instrumentoId: string): InstrumentoNavState {
  return { instrumentoId };
}

/** Lê o instrumento pedido do `location.state`; qualquer outra forma → `null`. */
export function readInstrumentoNavState(state: unknown): string | null {
  if (typeof state !== 'object' || state === null) return null;
  const id = (state as Partial<InstrumentoNavState>).instrumentoId;
  return typeof id === 'string' && id !== '' ? id : null;
}
